import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

function AccountPage() {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      let apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
      axios.get(`${apiBaseUrl}/users/me`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
        .then(response => {
          setUser(response.data);
        })
        .catch(error => {
          console.error('Error fetching user data:', error);
        });
    } else {
      // No token => not logged in => redirect to login (optional)
      navigate('/login');
    }
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem('token');
    // Option A: Force a full page reload so the nav updates:
    // window.location.reload();

    // Option B: Programmatic route + possibly re-check global auth state
    navigate('/login');
  };

  if (!user) {
    return <div>Loading user details...</div>;
  }

  return (
    <div style={{ textAlign: 'center', margin: '2rem' }}>
      <h1>Account Details</h1>
      <p>Email: {user.email}</p>
      <p>Username: {user.username}</p>
      <button
        onClick={handleLogout}
        style={{
          padding: '0.5rem 1rem',
          borderRadius: '4px',
          border: 'none',
          backgroundColor: '#cc0000',
          color: 'white',
          fontWeight: 'bold',
          cursor: 'pointer',
          marginTop: '1rem'
        }}
      >
        Logout
      </button>
    </div>
  );
}

export default AccountPage;
